export default "__VITE_ASSET__Bx1k7Ngh__"